import React, {useContext, useState} from "react";
import {Col, Container, Row, Tab, Tabs} from "react-bootstrap";

import './LearningProgress.css';
import StatusBar from "../StatusBar/StatusBar";
import MaxiIcon from "../Maxiicon/MaxiIcon";
import messages from "../../i18n/messages";
import {useIntl} from "react-intl";
import LearnChineseCharacter from "./LearnChineseCharacter/LearnChineseCharacter";
import {AuthContext} from "../../contexts/auth/AuthContext";
import LearnGermanAlphabet from "./LearnGermanAlphabet/LearnGermanAlphabet";
import LearnNumber from "./LearnNumber/LearnNumber";
import LearnAdmin from "./LearnAdmin/LearnAdmin";

const LearningProgress = () => {
    const intl = useIntl();
    const [authContext,] = useContext(AuthContext);
    const [key, setKey] = useState('chinese');

    return (
        <Container fluid className={'learning-progress'}>
            <StatusBar />
            <Row>
                <Col xs={12}>
                    <h2><MaxiIcon iconName={'faChalkboardTeacher'}/> {intl.formatMessage(messages.learningProgressLabel)}</h2>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12} md={12} xl={{span: 6, offset: 3}}>
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                    >
                        <Tab eventKey="chinese" title={intl.formatMessage(messages.learnChineseCharacterLabel)}>
                            <LearnChineseCharacter />
                        </Tab>
                        <Tab eventKey="deutsch" title={intl.formatMessage(messages.learnDeutschAlphabetLabel)}>
                            <LearnGermanAlphabet />
                        </Tab>
                        <Tab eventKey="number" title={intl.formatMessage(messages.learnNumberLabel)}>
                            <LearnNumber />
                        </Tab>
                        {authContext.isAdmin &&
                        <Tab eventKey="admin" title={intl.formatMessage(messages.adminLabel)}>
                            <LearnAdmin />
                        </Tab>
                        }
                    </Tabs>
                </Col>
            </Row>

        </Container>
    );
}

export default LearningProgress;